import css from 'styled-jsx/css';
import { colors, media } from '../../../../themes';

export default css`
  .price {
    color: ${colors.grayDeep};
    font-size: 1.3125em; /* 21/16 */
    font-weight: normal;
    line-height: normal;
    margin: 7px 0 3px;
  }

  .price.longNumber {
    font-size: 1.25em; /* 20/16 */
    font-weight: normal;
  }

  .change {
    display: inline-block;
    font-size: 0.6875em; /* 11/16 */
    color: ${colors.greenOlive};
    line-height: 0.2;
    margin-left: 7px;
    text-align: center;
  }

  .change strong {
    display: block;
  }

  :global(.rtl) .change {
    margin-left: 0;
    margin-right: 7px;
  }

  @media (min-width: ${media.mobile}) {
    .price {
      font-size: 32px;
    }
  }
`;



// WEBPACK FOOTER //
// ./app/components/shared/Labels/Price/styles.js